"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var TranscriptionStatusType;
(function (TranscriptionStatusType) {
    TranscriptionStatusType["STARTED"] = "started";
    TranscriptionStatusType["INTERRUPTED"] = "interrupted";
    TranscriptionStatusType["RESUMED"] = "resumed";
    TranscriptionStatusType["STOPPED"] = "stopped";
    TranscriptionStatusType["FAILED"] = "failed";
})(TranscriptionStatusType || (TranscriptionStatusType = {}));
exports.default = TranscriptionStatusType;
//# sourceMappingURL=TranscriptionStatusType.js.map